import { render, staticRenderFns } from "./PageSeparator.vue?vue&type=template&id=5a1c422a&"
import script from "./PageSeparator.vue?vue&type=script&lang=js&"
export * from "./PageSeparator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports